import { render, staticRenderFns } from "./user-tel-edit.vue?vue&type=template&id=2c7e7107&"
import script from "./user-tel-edit.vue?vue&type=script&lang=js&"
export * from "./user-tel-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports